import { useCallback, useSyncExternalStore } from "react";
import {
  APP_FEATURE_LABELS,
  type AppFeatureKey,
} from "src/Consts/features";
import {
  getAppFeatureAccessConfig,
  subscribeAppFeatureAccessConfig,
} from "src/Services/firebase/remote_config";

const useFeatureAccess = () => {
  const featureAccess = useSyncExternalStore(
    subscribeAppFeatureAccessConfig,
    getAppFeatureAccessConfig,
    getAppFeatureAccessConfig
  );

  const isFeatureEnabled = useCallback(
    (featureKey?: AppFeatureKey) => {
      if (!featureKey) return true;
      return featureAccess[featureKey];
    },
    [featureAccess]
  );

  return {
    featureAccess,
    isFeatureEnabled,
  };
};

const getFeatureLabel = (featureKey?: AppFeatureKey) =>
  featureKey ? APP_FEATURE_LABELS[featureKey] : "This feature";

export { getFeatureLabel, useFeatureAccess };
export type { AppFeatureKey };

